import { render, staticRenderFns } from "./RegisterOrganizerForm.vue?vue&type=template&id=628ee83c&scoped=true&"
import script from "./RegisterOrganizerForm.vue?vue&type=script&lang=js&"
export * from "./RegisterOrganizerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ee83c",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports